<template>
  <section class="contact-cta" :style="section.config.style">
    <div class="container">
      <div class="cta-content">
        <h2 class="cta-title">{{ section.config.title }}</h2>
        <p class="cta-subtitle">{{ section.config.subtitle }}</p>
        <p class="cta-description" v-if="section.config.description">{{ section.config.description }}</p>
        
        <div class="cta-buttons">
          <a 
            :href="section.config.primaryButton.link"
            :class="['btn', `btn-${section.config.primaryButton.style}`]"
          >
            {{ section.config.primaryButton.text }}
          </a>
          <a 
            v-if="section.config.secondaryButton"
            :href="section.config.secondaryButton.link"
            :class="['btn', `btn-${section.config.secondaryButton.style}`]"
          >
            {{ section.config.secondaryButton.text }}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactCTA',
  props: {
    section: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.contact-cta {
  padding: 80px 0;
  position: relative;
  overflow: hidden;
}

.contact-cta::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 70% 70%, rgba(255, 255, 255, 0.05) 0%, transparent 50%);
  pointer-events: none;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  position: relative;
  z-index: 1;
}

.cta-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.cta-title {
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: 800;
  margin-bottom: 1rem;
  line-height: 1.2;
}

.cta-subtitle {
  font-size: clamp(1.125rem, 2.5vw, 1.5rem);
  margin-bottom: 1rem;
  opacity: 0.9;
}

.cta-description {
  font-size: 1.125rem;
  line-height: 1.6;
  margin-bottom: 2.5rem;
  opacity: 0.8;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 2rem;
  border-radius: var(--radius-lg);
  font-weight: 600;
  font-size: 1rem;
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  min-width: 140px;
}

.btn-primary {
  background: white;
  color: var(--primary-color);
  border: 2px solid white;
}

.btn-primary:hover {
  background: rgba(255, 255, 255, 0.9);
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.btn-outline {
  background: transparent;
  color: white;
  border: 2px solid white;
}

.btn-outline:hover {
  background: white;
  color: var(--primary-color);
  transform: translateY(-2px);
}

/* 按钮光效 */
.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s;
}

.btn:hover::before {
  left: 100%;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .contact-cta {
    padding: 60px 0;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .btn {
    width: 100%;
    max-width: 300px;
  }
}
</style> 


// WEBPACK FOOTER //
// src/components/sections/ContactCTA.vue